import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'kh-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.less'],
  standalone: false
})
export class CarouselComponent implements AfterViewInit, AfterViewChecked {
  private readonly renderer = inject(Renderer2);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('carouselContainer') public carouselContainer!: ElementRef;
  @ViewChild('leftBtn') public leftBtn!: ElementRef;
  @ViewChild('rightBtn') public rightBtn!: ElementRef;
  @ViewChild('mainContainer') public mainContainer!: ElementRef;

  @Input() public visibleItems = 2;
  @Input() public steps = 1;
  @Input() public isVertical = false;
  @Input() public isMovedContainer = true;
  @Input() public btnUrl = '';
  @Input() public btnColor = '#CFDFE5';
  @Input() public btnPadding = 45;

  public sizeItemsContainer = '0px';

  private itemSize = 0;
  private itemPadding = 0;
  private currentItem = 0;
  private items!: HTMLElement[];
  private itemsCount = 0;

  public ngAfterViewInit(): void {
    this.items = this.carouselContainer.nativeElement.querySelectorAll('[kh-carousel-card]');
    this.itemsCount = this.items.length;
    this.setPositionItemsContainer(0);
    this.setVisibility();
    this.setContainerSize();
    this.items.forEach((item) => {
      this.renderer.setStyle(item, 'transition', '0.5s');
    });
    this.changeBtnVisibility();
    this.changeDetectorRef.detectChanges();
  }

  public ngAfterViewChecked(): void {
    this.setContainerSize();
    this.changeDetectorRef.detectChanges();
  }

  private setContainerSize(): void {
    if (!this.items.length) {
      return;
    }

    if (this.isVertical) {
      this.itemSize = this.items[0].offsetHeight;
      this.itemPadding = parseFloat(getComputedStyle(this.items[0]).marginBottom);
    }
    else {
      this.itemSize = this.items[0].offsetWidth;
      this.itemPadding = parseFloat(getComputedStyle(this.items[0]).marginRight);
    }

    if (this.visibleItems <= this.items.length) {
      this.sizeItemsContainer = `${this.itemSize * this.visibleItems + this.itemPadding * (this.visibleItems - 1) + this.btnPadding * 2}px`;
    }
    else {
      this.sizeItemsContainer = `${this.itemSize * this.items.length + this.itemPadding * (this.items.length - 1) + this.btnPadding * 2}px`;
    }
  }

  public moveItemsOnMultipleSteps(isRight: boolean): void {
    for (let i = 0; i < this.steps; i++) {
      this.moveItems(isRight);
    }
  }

  public moveItems(isRight: boolean): void {
    if (isRight) {
      if (this.currentItem + 1 <= this.itemsCount - this.visibleItems) {
        this.currentItem++;
        this.setVisibility();
      }
    }
    else {
      if (this.currentItem - 1 >= 0) {
        this.currentItem--;
        this.setVisibility();
      }
    }

    this.changeBtnVisibility();
    this.setPositionItemsContainer(-(this.itemSize + this.itemPadding) * this.currentItem);
  }

  private setVisibility(): void {
    this.items.forEach((item) => {
      this.setItemVisibility(item, 1);
    });

    const previousItemIndex = this.currentItem - 1;
    const nextItemIndex = this.currentItem + this.visibleItems;
    if (previousItemIndex >= 0) {
      this.setItemVisibility(this.items[previousItemIndex], 0);
    }

    if (nextItemIndex < this.itemsCount) {
      this.setItemVisibility(this.items[nextItemIndex], 0);
    }
  }

  private setItemVisibility(item: HTMLElement, status: number): void {
    this.renderer.setStyle(item, 'opacity', status);
  }

  private setPositionItemsContainer(position: number): void {
    this.renderer.setStyle(
      this.carouselContainer?.nativeElement,
      this.isVertical ? 'top' : 'left',
      `${position}px`);
  }

  private changeBtnVisibility(): void {
    if (this.currentItem + 1 > this.itemsCount - this.visibleItems) {
      this.removeRightBtn();
    }
    else {
      this.addRightBtn();
    }

    if (this.currentItem - 1 < 0) {
      this.removeLeftBtn();
    }
    else {
      this.addLeftBtn();
    }
  }

  private removeRightBtn(): void {
    this.setBtnVisibility(this.rightBtn?.nativeElement, 'hidden');
  }

  private removeLeftBtn(): void {
    this.setBtnVisibility(this.leftBtn?.nativeElement, 'hidden');
    if (this.isMovedContainer) {
      this.setMarginMainContainer(-this.btnPadding);
    }
  }

  private addRightBtn(): void {
    this.setBtnVisibility(this.rightBtn?.nativeElement, 'visible');
  }

  private addLeftBtn(): void {
    this.setBtnVisibility(this.leftBtn?.nativeElement, 'visible');
    if (this.isMovedContainer) {
      this.setMarginMainContainer(0);
    }
  }

  private setBtnVisibility(item: HTMLElement, status: 'hidden' | 'visible'): void {
    this.renderer.setStyle(item, 'visibility', status);
  }

  private setMarginMainContainer(value: number): void {
    this.renderer.setStyle(
      this.mainContainer?.nativeElement,
      this.isVertical ? 'margin-top' : 'margin-left',
      `${value}px`);
  }
}
